export const MAX_PHONE_VERIFICATION_ATTEMPTS = 5;

export const MASKED_PHONE_DIGITS = 4;

// Backend API error codes
export const PHONE_VERIFICATION_ERROR_CODES = {
    INVALID_PHONE: 'ERR_OTP_INVALID_PHONE',
    TOO_MANY_ATTEMPTS: 'ERR_OTP_PHONE_TOO_MANY_ATTEMPTS',
    INTERNAL_ERROR: 'ERR_OTP_INTERNAL_ERROR',
    ERR_OTP_INVALID_CODE: 'ERR_OTP_INVALID_CODE',
    ERR_OTP_VERIFY_TOO_MANY_ATTEMPTS: 'ERR_OTP_VERIFY_TOO_MANY_ATTEMPTS',
    ERR_OTP_VERIFY_EXPIRED: 'ERR_OTP_VERIFY_EXPIRED',
    ERR_OTP_VERIFY_INTERNAL_ERROR: 'ERR_OTP_VERIFY_INTERNAL_ERROR'
};

export const EMAIL_OTP_ERROR_CODES = {
    INVALID_CODE: 'ERR_OTP_INVALID_CODE',
    TOO_MANY_ATTEMPTS: 'ERR_OTP_VERIFY_TOO_MANY_ATTEMPTS'
};

// HTTP status codes
export const HTTP_STATUS = {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500
};

export const MFA_MODE = {
    PHONE: 'phone',
    EMAIL: 'email'
};
